import HttpClient from '../request/HttpClient';
import { saveLocalData, getLocalData, isCsairApp } from '../app';
var request = new HttpClient({
    timeout: 0,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'x-requested-with': 'XMLHttpRequest',
    },
}, {
    store: {
        clearData: function (key) {
            if (isCsairApp()) {
                saveLocalData(key, '');
            }
            else {
                localStorage.removeItem(key);
            }
        },
        getData: function (key) {
            return getLocalData(key);
        },
        setData: function (key, data) {
            saveLocalData(key, data);
        },
    },
});
export default function getUpgradesCodeMsg() {
    return request.createHttp('get', "/public/apiStatusCodeMsg/cn/checkOrderTicket.change.u.json", { cache: 'local', loading: false });
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/setUpgradesMsg.js
// module id = null
// module chunks = 